import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../theme/ISpcTheme';

export type IIndicativeNumberClasses = 'indicativeNumber';

const indicativeNumberStyles = makeStyles<ISpcTheme, { topOffset: number }, IIndicativeNumberClasses>(
  ({ spacing, typography, breakpoints }) => ({
    indicativeNumber: {
      marginLeft: spacing(0.5),
      fontSize: typography.fontXXS,
      position: 'relative',
      cursor: 'pointer',
      top: ({ topOffset }) => (topOffset ? `-${topOffset}px` : '-5px'),

      [breakpoints.down('md')]: {
        top: ({ topOffset }) => (topOffset ? `-${topOffset - 1}px` : '-5px'),
      },
    },
  }),
  { name: 'Customise_IndicativeNumber' },
);

export default indicativeNumberStyles;
